import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatMessageTime } from "@/shared/lib/formatMessageTime";

type ChatMessageTimeProps = {
  at: number;
  /** How the response ended; the bare time (a question's) without it. */
  outcome?: "completed" | "cancelled";
};

/** A message's time, under it: short and muted. */
export function ChatMessageTime({ at, outcome }: ChatMessageTimeProps) {
  const { t } = useTranslation("chat");
  const time = formatMessageTime(at);
  const label =
    outcome === "completed"
      ? t("message.completedAt", { time })
      : outcome === "cancelled"
        ? t("message.cancelledAt", { time })
        : time;

  return (
    <Typography
      component="time"
      dateTime={new Date(at).toISOString()}
      variant="caption"
      sx={{ color: "var(--theme-text-secondary)", lineHeight: 1.4 }}
    >
      {label}
    </Typography>
  );
}
